export default {
  path: 'send-sms',
  name: 'SendSms',
  component: () => import(/* webpackChunkName: "sms" */ '../views/SendSmsView.vue')
}
